import PropTypes from 'prop-types';
export const countdownTimerPropTypes = {
  endDate: PropTypes.string
};